import { useState } from "react";
import { Button } from "../ui/button";
import DownloadIcon from "../ui/icons/DownloadIcon";
import { Text } from "../ui/text";
import { exportWord, exportPdf } from "@/utils/export";
import { Reference } from "../message/message-list";
import Spinner from "../shared/spinner";

const getFileName = () => {
  const date = new Date().toISOString().split("T")[0].replace(/-/g, ".");
  return `Report_${date}`;
};

const ReportDownloadButton = ({
  type,
  content,
  references = [],
  createdAt,
}: {
  type: "pdf" | "word";
  content: string;
  references?: Reference[];
  createdAt?: string;
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleDownload = async () => {
    if (isLoading) return;

    setIsLoading(true);
    try {
      const fileName = getFileName();

      if (type === "pdf") {
        await exportPdf({ content, references, fileName, createdAt });
      } else {
        await exportWord({ content, references, fileName, createdAt });
      }
    } catch (error) {
      console.error(`${type.toUpperCase()} 다운로드 중 오류 발생:`, error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Button
        onClick={handleDownload}
        disabled={isLoading}
        className="border border-primary-80 rounded-[8px] px-4 py-[10px] disabled:opacity-50 disabled:cursor-not-allowed"
        style={{
          background:
            "linear-gradient(144deg, #ECFCFA 13.78%, #FEF9F7 49.93%, #FFF 86.08%)",
        }}
      >
        <DownloadIcon color="#333333" />
        <Text variant="body-regular">{type === "pdf" ? "PDF" : "Word"}</Text>
      </Button>
      {isLoading && <Spinner />}
    </>
  );
};

export default ReportDownloadButton;
